import { Field } from "@progress/kendo-react-form";
import {
  FormDropDownListById,
  FormInput,
  FormRadioGroup,
} from "../../../../forms/form-components";
import { useDispatch, useSelector } from "react-redux";
import { FormRegion } from "../../../../components/formregion";
import { useTranslation } from "react-i18next";
import { ReQuartzCron } from "@sbzen/re-cron";

const RecurrenceNotificationStep = (props) => {
  //#region state
  const pageState = useSelector((state) => state.importSchedulePage);
  const appearance = useSelector((state) => state.appearance);
  const currentTheme = useSelector((state) => state.currentTheme);

  const { t } = useTranslation();

  const ddlRecurrsEvery = [
    { Id: 0, Title: t("slices.none") },
    { Id: 5, Title: t("slices.fiveMins") },
    { Id: 10, Title: t("slices.tenMins") },
    { Id: 15, Title: t("slices.fiveteenMins") },
    { Id: 30, Title: t("slices.thirtyMins") },
    { Id: 60, Title: t("slices.oneHour") },
    { Id: 120, Title: t("slices.twoHours") },
    { Id: 180, Title: t("slices.threeHours") },
    { Id: 240, Title: t("slices.fourHours") },
    { Id: 300, Title: t("slices.fiveHours") },
    { Id: 360, Title: t("slices.sixHours") },
    { Id: 720, Title: t("slices.twelveHours") },
    { Id: 1440, Title: t("slices.oneDay") },
    { Id: 2880, Title: t("slices.twoDays") },
    { Id: 4320, Title: t("slices.threeDays") },
    { Id: 10080, Title: t("slices.sevenDays") },
    { Id: 43200, Title: t("slices.thirtyDays") },
  ];

  const CronOptionLabel = () => {
    return (
      <span className="cron-option-label">
        <span>{t("schedule.selectcron")}</span>

        <span
          className="cron-help-icon"
          title={t("schedule.learnmore")}
          onClick={(e) => {
            e.stopPropagation(); // prevent radio toggle
            window.open("https://recron.emptyui.com/", "_blank");
          }}
        >
          ?
        </span>
      </span>
    );
  };

  const selectFromList = [
    { label: t("schedule.selecttime"), value: "fromRecurrency" },
    {
      label: <CronOptionLabel />,
      value: "fromCron",
    },
  ];
  //#endregion

  return (
    <FormRegion>
      <div className="form-group form-group-1">
        <Field
          id={"RecurrencyFrom"}
          name={"RecurrencyFrom"}
          label={t("alerts.recurs")}
          component={FormRadioGroup}
          data={selectFromList}
          value={pageState.formValues.RecurrencyFrom}
          onChange={props.onRecurrencyOptionChange}
        />
        {pageState.formValues.RecurrencyFrom == "fromRecurrency" && (
          <Field
            id={"RecurrsEvery"}
            name={"RecurrsEvery"}
            label={t("alerts.recurs")}
            component={FormDropDownListById}
            data={ddlRecurrsEvery}
            dataItemKey="Id"
            textField="Title"
            onChange={(e) =>
              props.onChangeFormValue("RecurrsEvery", e.value, props.onChange)
            }
          />
        )}
        {pageState.formValues.RecurrencyFrom == "fromCron" && (
          <>
            <Field
              id={"CronValue"}
              name={"CronValue"}
              label={t("schedule.CronValue")}
              disabled
              component={FormInput}
              style={{ marginBottom: "20px" }}
            />

            <ReQuartzCron
              value={pageState.formValues.CronValue}
              onChange={(e) =>
                props.onChangeFormValue("CronValue", e, props.onChange)
              }
            />
          </>
        )}
      </div>
      <style>
        {`        
            .create-schedule-page > .content .form-root .k-form .k-form-field{
              width:100%;
            } 
            .create-schedule-page .form-group .upload-button{    
              width: 15%;
              margin-left: 2%;
              height: 48px;
              margin-top: 25px;
            }
            .create-schedule-page .form-group .rows-container{
              display: flex; 
              justify-content:space-between ; 
              margin-top:20px;
              margin-bottom:50px;
            }
            .create-schedule-page .form-group .rows-container .k-form-field{
              width:48% !important;
            } 
            .create-schedule-page .form-group .rows-container .k-form-field:nth-child(2) {
                margin-top: 4px !important;
            }
            .create-schedule-page .form-group .rows-container .k-radio-list{
              display: flex; 
              flex-direction: row;
              justify-content:space-between ; 
              margin-top:0;
              margin-bottom:0;
            } 
            .create-schedule-page .form-group .import-checkbox{
              margin-bottom:20px;
              display:block;
              float:${appearance.isRightToLeft ? "right" : "left"};
            }

            .create-schedule-page .form-group .nav-tabs .nav-link{
              color:${currentTheme.primary}
            }


            .cron-option-label {
              display: inline-flex;
              align-items: center;
              gap: 6px;
            }

            .cron-help-icon {
              cursor: pointer;
              font-size: 11px;
              font-weight: bold;
              border: 1px solid #000;
              border-radius: 50%;
              width: 15px;
              height: 15px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              user-select: none;
              line-height: 14px;
            }

          `}
      </style>
    </FormRegion>
  );
};

export default RecurrenceNotificationStep;
